import type { ReactElement, ReactNode } from 'react';
import { ProgressBar } from '@betrybe/ada-react';

import clsx from 'clsx';

export type CardProps = {
  step?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  titleAlign?: 'left' | 'right' | 'center';
  cardSize?: 'big-card' | 'normal-card' | 'large-card';
  progressPercentage?: number;
  limitDate?: string;
};

function Card({
  step,
  children,
  title,
  description,
  titleAlign = 'left',
  cardSize = 'normal-card',
  progressPercentage,
  limitDate,
}: CardProps): ReactElement {
  let limitDateToView: string | null | undefined;
  if (limitDate) {
    const dateSplit = limitDate.split('-');
    limitDateToView = `${dateSplit[2] || ''}/${dateSplit[1] || ''}`;
  }

  const hasLimitDate = () => {
    if (progressPercentage && progressPercentage === 100 && limitDateToView) {
      return (
        <>
          Aguarde até <strong>7 dias corridos</strong>
        </>
      );
    }
    if (progressPercentage && limitDateToView) {
      return (
        <>
          Finalize até <strong>{limitDateToView}</strong>
        </>
      );
    }
    if (progressPercentage && !limitDateToView) {
      return (
        <>
          Aguarde até <strong>7 dias corridos</strong>
        </>
      );
    }
    return <></>;
  };

  return (
    <div className={`card-container card-container__${cardSize}`}>
      <div className="card-container__label-groups">
        <div className="card-container__progress-bar-group">
          <div className="card-container__progress-bar-group--step-group">
            <div className="card-container__step">{step}</div>
            {progressPercentage && (
              <div className="card-container__progress-bar-group--limit-date">
                {hasLimitDate()}
              </div>
            )}
          </div>
          {progressPercentage && (
            <ProgressBar
              percentage={progressPercentage}
              compact
              barColor="#704488"
              backgroundColor="#DCCDE4"
            />
          )}
        </div>
        <h1
          className={clsx(
            'card-container__title',
            `card-container__title--${titleAlign}`,
          )}
        >
          {title}
        </h1>
        <div className="card-container__description">{description}</div>
      </div>
      {children}
    </div>
  );
}

export default Card;
